module.exports = __webpack_public_path__ + "img/ch2video.8b84a1cc.png";